var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":("【" + _vm.className + "】历史成绩"),"fullscreen":true},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('ClassHistory',{attrs:{"classId":_vm.classId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }